import React from 'react';
import {
  Box,
  Stack,
  Paper,
  Typography,
  Button,
  IconButton
} from '@mui/material';
import { InsertDriveFile, UploadFile, DeleteOutline } from '@mui/icons-material';
import { Skeleton } from '@mui/material';
import palette from 'src/theme/palette';

const DocumentShimmerLoader = () => (
  <Paper
    variant="outlined"
    sx={{ p: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
  >
    <Stack direction="row" spacing={1} alignItems="center">
      <Skeleton variant="circular" width={24} height={24} />
      <Skeleton variant="text" width={150} height={20} />
    </Stack>
    <Skeleton variant="circular" width={32} height={32} />
  </Paper>
);

const PropertyDocumentsTab = ({
  form,
  uploadingDocuments,
  handleDocUpload,
  removeDocument,
  handleDocumentClick,
  loadingProperty
}) => {
  return (
    <Box>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Property Documents
      </Typography>

      <input
        accept=".pdf,.doc,.docx,.txt"
        id="docs-upload"
        multiple
        type="file"
        style={{ display: 'none' }}
        onChange={handleDocUpload}
        disabled={loadingProperty}
      />
      <label htmlFor="docs-upload">
        <Button
          variant="outlined"
          component="span"
          startIcon={<InsertDriveFile />}
          disabled={loadingProperty}
        >
          Upload Documents
        </Button>
      </label>

      <Stack spacing={1} sx={{ mt: 2 }}>
        {uploadingDocuments.map((doc, i) => (
          <DocumentShimmerLoader key={`uploading-doc-${i}`} />
        ))}

        {form.documents.length === 0 && uploadingDocuments.length === 0 && (
          <Typography variant="body2">
            {loadingProperty ? 'Loading documents...' : 'No documents uploaded.'}
          </Typography>
        )}

        {form.documents.map((doc, i) => (
          <Paper
            key={i}
            variant="outlined"
            sx={{
              p: 1,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderColor: doc.uploadError ? palette.error.main : undefined,
              backgroundColor: doc.uploadError ? palette.error.lighter : undefined,
              cursor: 'pointer'
            }}
            onClick={() => handleDocumentClick(doc.serverUrl)}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <UploadFile color={doc.uploadError ? 'error' : 'action'} />
              <Box>
                <Typography variant="body2" color={doc.uploadError ? 'error' : 'textPrimary'}>
                  {doc.name}
                </Typography>
                {doc.uploadError && (
                  <Typography variant="caption" color="error">
                    {doc.errorMessage}
                  </Typography>
                )}
              </Box>
            </Stack>
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                removeDocument(i);
              }}
              color={doc.uploadError ? 'error' : 'default'}
              disabled={loadingProperty}
            >
              <DeleteOutline />
            </IconButton>
          </Paper>
        ))}
      </Stack>
    </Box>
  );
};

export default PropertyDocumentsTab;